// src/adai/components/history/StatusBadge.jsx
// Thin wrapper — real implementation in shared/ui/StatusBadge.jsx
// (map: "adai", see shared/ui/statusMaps.js's `adaiJobStatusMap`).
import StatusBadge from "../../../shared/ui/StatusBadge";

const AdaiStatusBadge = ({ status }) => <StatusBadge map="adai" status={status} />;

export default AdaiStatusBadge;
